<template>
<div class="backoffice-pos">
<v-row>
    <v-col cols="12" md="7" sm="5">
        <v-row style="margin-bottom:30px; margin-right:1px">
            <v-col colas="12">
            <v-autocomplete
                append-icon=""
                prepend-inner-icon="mdi-magnify"
                hide-no-data
                multiple hide-details
                hide-selected
                v-model="searchField"
                @change="addToCart"
                item-text="name" 
                return-object
                :items="resultProducts" 
                :search-input.sync="searchProducts"
                :placeholder="$page.props.lang.filter_search || 'Search'"
                dense solo  class="search-products">
               <template v-slot:item="data">
                    <v-list-item-content>
                        <v-list-item-title v-html="data.item.full_name"></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-btn v-if="data.item.is_checkedin == false" @click.stop.prevent="checkIn(data.item)" small outlined color="primary">{{ $page.props.lang.check_in || "Check-in" }}</v-btn>
                        <span v-else>Vec je prijavljen</span>
                    </v-list-item-action>
                </template>
            </v-autocomplete>
            </v-col>
        </v-row>
        <v-row style="margin-right:1px">
            <v-tabs v-model="tab">
                <v-tabs-slider></v-tabs-slider>
                <v-tab v-for="category in categories" :key="category.id" :href="'#tab-' + category.id" @click="getProducts(category.id)">{{ category.name }}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                 <v-tab-item></v-tab-item>
            </v-tabs-items>
        </v-row>
        <v-row style="margin-right:0px; margin-left:0px">
            <v-col cols="12" md="3" sm="6" v-for="prod in currentProducts" :key="prod.id" @click="addToCart(prod)">
                <v-card style="cursor:pointer" exact tile>
                    <v-card-title :title="prod.name" style="white-space: nowrap; width:100%; text-overflow: ellipsis; overflow: hidden; ">{{prod.name}}</v-card-title>
                  <v-card-text class="text-right">
                      <span>{{prod.price | currency($page.props.organization.settings.currency)}}</span>
                  </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-col>
    <v-col cols="12" md="5" sm="7">
         <v-card elevation="1" >
            <v-select style="padding-left:2px; padding-right:4px" v-model="cart.member_id" 
                :items="members"
                item-text="full_name"
                item-value="id"
                single-line
                menu-props="auto"
                prepend-icon="mdi-account-circle"
                :label="$page.props.lang.select_member || 'Select member'" clearable
                :hide-details="!responseErrors.member_id"
                :error-messages="responseErrors.member_id" 
                @focus="responseErrors.member_id=''">
            </v-select>
            <v-card-text style="height:350px; overflow-y: auto;">
                <v-row v-for="item in cart.items" :key="item.id">
                    <v-col cols="6" sm="5">
                        {{ item.name }}
                    </v-col>
                    <v-col cols="1" sm="2">
                       <span style="text-decoration:underline; cursor:pointer" @click="openQtyModal(item)">  {{ item.qty }} </span>
                    </v-col>
                    <v-col cols="3">
                        {{ item.price | currency($page.props.organization.settings.currency)}}
                    </v-col>
                    <v-col cols="2" class="text-right">
                        <v-btn icon color="error" fab x-small @click="removeFromCart(item)"><v-icon>mdi-delete</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-dialog v-model="qtyModal" max-width="250px">
                <v-card>
                    <div class="modal-header">
                        <h4 class="modal-headline">{{ this.currentCartItem.name}}</h4>
                        <div class="tools">
                            <v-btn icon @click="qtyModal = false"><v-icon>mdi-close</v-icon></v-btn>
                        </div>
                    </div>
                    <div class="text-center">
                        <v-icon v-if="this.currentCartItem.qty > 1" color="red" @click="removeItemQty" style="cursor:pointer" class="mb-2">mdi-minus-circle-outline</v-icon> 
                        <v-icon v-else color="red" disabled class="mb-2">mdi-minus-circle-outline</v-icon> 
                        <v-chip label large class="ma-2 mb-3"><v-icon left>mdi-cart</v-icon>{{this.currentCartItem.qty}}</v-chip>
                        <v-icon color="green" @click="addItemQty" style="cursor:pointer" class="mb-2">mdi-plus-circle-outline</v-icon>
                    </div>
                    <div class="text-right">
                        <v-btn style="mt-2 pt-2" block color="primary" @click="confirmItemsQty" >{{ $page.props.lang.confirm || 'Confirm'}}</v-btn>
                    </div>
                </v-card>
            </v-dialog>
            <v-card-text>
            <div class="pos-summary">
                <!-- <v-row>
                    <v-col cols="6">
                        <span>{{ $page.props.lang.subtotal||'Subtotal'}}:</span>
                    </v-col>
                    <v-col cols="6" class="text-right">
                        {{subtotal_cart | currency($page.props.organization.settings.currency)}}
                    </v-col>
                </v-row> -->
                <!-- <v-row>
                    <v-col cols="6">
                        {{ $page.props.lang.tax||'Tax'}}:
                    </v-col>
                    <v-col cols="6" class="text-right">
                        00.00 %
                    </v-col>
                </v-row> -->
                <v-row>
                    <v-col cols="6">
                       <span style="font-weight: bold;">{{ $page.props.lang.total||'Total'}}:</span>
                    </v-col>
                    <v-col cols="6" class="text-right">
                         <span style="font-weight: bold;">{{subtotal_cart | currency($page.props.organization.settings.currency)}}</span>
                    </v-col>
                </v-row> 
            </div>
            </v-card-text>
            <v-btn block color="primary" @click="openPaymentModal" >{{ $page.props.lang.pay || 'Pay'}}</v-btn>
        </v-card>  
    </v-col>
</v-row>

<v-dialog v-if="paymentModal" v-model="paymentModal" max-width="500px" content-class="payment">
    <v-card>
        <div class="modal-header">
                     <v-card-title>Plaćanje</v-card-title>
                    <div class="tools">
                        <v-btn icon @click="paymentModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
        <v-card-text>
           <h2 style="padding-top:10px" class="mb-3"> {{ $page.props.lang.total || "Total price"}} : {{subtotal_cart}} <span class="table-currency">{{ $page.props.organization.settings.currency }}</span></h2>
           <div class="form-group">
                <label class="custom-label">{{ $page.props.lang.payment_method || 'Payment method'}}</label>     
                <v-select v-model="cart.payment_type_id" 
                    :items="paymentTypes" item-text="name" item-value="id" 
                    outlined dense :hide-details="!responseErrors.payment_type_id"
                    :error-messages="responseErrors.payment_type_id" 
                    @focus="responseErrors.payment_type_id=''">
                </v-select>
           </div>
           <div>
               <label class="custom-label">Napomena</label>
               <v-textarea v-model="cart.note" outlined dense></v-textarea>
           </div> 
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="completeOrder()" :loading="saving" color="primary" class="mt-6">{{ $page.props.lang.markPayed || "Mark payed" }}</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</div>
</template>

<style scoped>
.cart-item{
    border-bottom: 1px solid #ddd;
}
</style>

<script>

import AppLayout from '@/js/Layouts/AppLayout'
import Button from '../../../Jetstream/Button.vue'
import EventBus from '@/js/eventbus'

export default {
  components: { Button },
    metaInfo() {
        return {
            title: this.$page.props.lang.title || "POS"
        }
    },
    layout: AppLayout,
    props:{
        categories: Array,
        products: Array,
        members: Array,
        paymentTypes: Array
    },
    data(){
        return {
            isLoading: false,
            saving: false,
            paymentModal: false,
            searchField: [],
            responseErrors:[],
            // payment_type_id: null,
            searchProducts: null,
            resultProducts: [],
            cart:{
                items: [],
                total: 0,
                subtotal:0,
                member_id:null, 
                payment_type_id: null,
                note: ' '
            },
            tab:null,
            currentCategory: this.categories[0].id,
            currentProducts: [],
            qtyModal: false,
            currentCartItem:{}
        }
    },
    watch:{
        searchProducts(val) {

         
            if (val === null) {
                this.resultProducts= []
                return
            } 

           // if(this.resultProducts.length > 0) return
            if (this.isLoading) return

            this.isLoading = true

            axios.get('/backoffice/lookup/products', { params: { search: val }})
                .then(response => {
                    this.resultProducts = response.data.results
                    this.isLoading = false
                })
        },
    },
    computed:{
        subtotal_cart: function(){

            let numOr0 = n => isNaN(n) ? 0 : n 
            if( this.cart.items.length > 0){
                this.cart.subtotal = this.cart.items.map(item => item.price).reduce((prev, next) => numOr0(parseFloat(prev)) + numOr0(parseFloat(next)));
                this.cart.total = this.cart.subtotal;
                return this.cart.subtotal;
                // return this.cart.items.map(item => item.price).reduce((prev, next) => numOr0(parseFloat(prev)) + numOr0(parseFloat(next)));
            }

            return 0;
        },
    },
    created(){
        this.getProducts(this.currentCategory);
    },
    methods:{

        openQtyModal(item){
            
            let current = this.cart.items.filter(x => x.id == item.id);
            this.currentCartItem = {
                id: current[0].id,
                sku:current[0].sku,
                name: current[0].name,
                price: current[0].price,
                quantity: current[0].quantity,
                qty:current[0].qty,
                unit_price: current[0].unit_price
            };
            this.qtyModal = true;
        },

        addToCart(prod){
            if(prod.length == undefined){
                var item = {
                    id: prod.id,
                    sku: prod.sku,
                    name: prod.name,
                    quantity: prod.qty,
                    qty:1,
                    unit_price: prod.price,
                    price: prod.price
                }
                var existing = this.cart.items.filter(x => x.id == prod.id);
            }else{
                var item = {
                    id: prod[prod.length - 1].id,
                    sku: prod[prod.length - 1].sku,
                    name: prod[prod.length - 1].name,
                    quantity: prod[prod.length - 1].qty,
                    qty:1,
                    unit_price: prod[prod.length - 1].price,
                    price: prod[prod.length - 1].price
                }
                var existing = this.cart.items.filter(x => x.id == prod[prod.length - 1].id);  
            }

           if(existing.length == 1){
               if(existing[0].quantity > existing[0].qty)
               {
                existing[0].qty++;
                existing[0].price = existing[0].qty * existing[0].unit_price;
               }
               else{
                   EventBus.$emit('SHOW_NOTIFICATION', {
                            message: this.$page.props.lang.no_products_available || "The product is out of stock!",
                            color: 'error',
                            timeout: 5000
                    });
               }
           }else{
                this.cart.items.push(item)
           }

           this.searchProducts = null;

        },

        addItemQty(){
            this.currentCartItem.qty++;
            this.currentCartItem.price = this.currentCartItem.qty * this.currentCartItem.unit_price;
        },

        removeItemQty(){
            this.currentCartItem.qty--;
            this.currentCartItem.price = this.currentCartItem.qty * this.currentCartItem.unit_price;
        },  

        confirmItemsQty(){
            let objIndex = this.cart.items.findIndex((obj => obj.id == this.currentCartItem.id));
            // if(this.cart.items[objIndex].quantity >= this.currentCartItem.qty){
                this.cart.items[objIndex].qty = this.currentCartItem.qty;
                this.cart.items[objIndex].price = this.currentCartItem.price;
            // }
            // else{
            //     EventBus.$emit('SHOW_NOTIFICATION', {
            //                 message: this.$page.props.lang.no_products_available || "There are not enough products in stock",
            //                 color: 'error',
            //                 timeout: 5000
            //         });
            // }
            
            this.qtyModal = false;
        },

        addQty(prod){
            prod.qty++;

            prod.price = prod.qty * prod.unit_price;
        },
        removeQty(prod){

            prod.qty--;
            prod.price = prod.qty * prod.unit_price;

            if(prod.qty == 0){

                var index = this.cart.items.indexOf(prod);

                this.cart.items.splice(index, 1);

            }
        },

        removeFromCart(item){
            var index = this.cart.items.indexOf(item);

            this.cart.items.splice(index, 1);
        },

        openPaymentModal(){
            if(this.cart.items.length == 0){
                this.paymentModal = false;
                EventBus.$emit('SHOW_NOTIFICATION', {
                            message: this.$page.props.lang.no_products || "You must add products first!",
                            color: 'error',
                            timeout: 5000
                    });
            }else if(this.cart.member_id == null){
                this.paymentModal = false;
                EventBus.$emit('SHOW_NOTIFICATION', {
                            message: this.$page.props.lang.no_member || "You must choose member first!",
                            color: 'error',
                            timeout: 5000
                    });
            }
            else{
            this.paymentModal = true;
            }
        },

        completeOrder(){
            this.sending = true;
            axios.post('/backoffice/pos/createOrder', this.cart)
                .then(response => {
                    var color = "error";
                    if(response.data.status==="OK") {
                        this.sending = false;
                        color = "success";
                        this.cart = {
                            items: [],
                            total: 0,
                            subtotal:0,
                            member_id:null,
                            payment_type_id: null,
                            note: ''
                        }
                        }
                        EventBus.$emit('SHOW_NOTIFICATION', {
                            message: response.data.message,
                            color: color,
                            timeout: 5000
                    });
                    this.paymentModal = false;
                })
                .catch(error => {
                    this.sending = false;
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 5000
                    });
                    this.responseErrors = error.response.data.errors
                })
            

        },

        getProducts(id){
            axios.get('/backoffice/products/getCurrentProducts/'+ id)
                .then(response => {
                    if(response.data.status === "OK"){
                        this.currentProducts = response.data.current_products
                    }else{
                        alert(response.data.message)
                    }
            });
        }
    },
    filters:{
        currency(value, curency){
            return (Math.round(value * 100) / 100).toFixed(2) + ' '+curency;

        }
    }
}
</script>
